/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ExistsUnprocessedEventsRequest} from '@cash-web/protos/squareup/timecards/service.pb'
import {ExistsUnprocessedEventsResponse} from '@cash-web/protos/squareup/timecards/service.pb'


export const existsUnprocessedEvents = (request: ExistsUnprocessedEventsRequest, options?: CashRequestOptions) => post<ExistsUnprocessedEventsRequest, ExistsUnprocessedEventsResponse>("/proxy/services/squareup.timecards.TimecardUpdatesFeedReportingService/ExistsUnprocessedEvents", request, {...options, rejectOnError: true })